import * as models from "app/models/requireme";
import * as kea from "kea-react";

type Entity = models.PartidaAclaracionDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas : Column[] = [
    {title: "Folio", cell: x => ({data: x.Folio })},
    {title: "Total", cell: x => ({data: kea.formatCurrency(x.Total) })},
    {title: "Fecha creación", cell: x => ({data: kea.toDate(x.FechaCreacion) })},
    {title: "Al día", cell: x => ({data: kea.toDate(x.FechaAlDia) })},
    {title: "Guias", cell: x => ({data: x.CantidadGuias })},
    {title: "Facturas", cell: x => ({data: x.CantidadFacturas })},
    {title: "Depositos", cell: x => ({data: x.CantidadDepositos })},
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>) : Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ... columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/list/columns.tsx